import { SlotsMinigame, NUMBERS } from '@phaser/minigames/slots';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class SlotsRow {
  private _background: Phaser.GameObjects.Rectangle;
  private _mask: Phaser.Display.Masks.GeometryMask;
  private _cells: Phaser.GameObjects.Text[] = [];
  private _speed = Math.random() * 0.2 + 0.1;
  private _scene: Game = Game.current;
  private _isStopped = false;
  private _cellSize = 0;

  constructor(
    private slotsMinigame: SlotsMinigame,
    private index: number,
    private x: number,
    private y: number,
    private width: number,
    private height: number,
    private direction: 'down' | 'up',
  ) {
    this._cellSize = this.width;

    this._placeRow();
    this._fillRow();
    this._registerEvents();
  }

  public stopRow(callParent = true) {
    if (this._isStopped) return;

    const camera = this._scene.cameras.main;
    const middle = camera.displayHeight / 2;

    this._isStopped = true;

    const closest = this._cells.reduce((prev, curr) => {
      const prevDist = Math.abs(prev.y - middle);
      const currDist = Math.abs(curr.y - middle);
      return prevDist < currDist ? prev : curr;
    });

    const offsetToMiddle = closest.y - middle;

    this._cells.forEach(cell => {
      this._scene.add.tween({
        y: `-=${offsetToMiddle}`,
        ease: 'Power2',
        targets: cell,
        duration: 500,
      });
    });

    if (!callParent) return;

    this.slotsMinigame.rowStop(closest.text, this.index);
  }

  public update(_time: number, delta: number) {
    if (this._isStopped) return;

    this._cells.forEach(cell => {
      if (this.direction === 'up') {
        cell.y -= this._speed * delta;
        if (cell.y <= this.y - this._cellSize) {
          cell.y = this.y + this.height + this._cellSize;
        }
      } else {
        cell.y += this._speed * delta;
        if (cell.y > this.y + this.height + this._cellSize) {
          cell.y = this.y - this._cellSize;
        }
      }
    });
  }

  public destroy() {
    this._background.destroy();
    this._cells.forEach(cell => cell.destroy());
    this._mask.destroy();
  }

  private _fillRow() {
    const cellAmount = Math.round(this.height / this.width) + 2;
    const sequence = Array.from({ length: 4 })
      .flatMap(() => NUMBERS)
      .slice(0, cellAmount);

    for (let i = 0; i < sequence.length; i++) {
      const xPos = this.x + (this._cellSize / 2);
      const yPos = this.y + (this._cellSize / 2) + (i * this._cellSize) - this._cellSize;

      const text = this._scene.add.text(xPos, yPos, sequence[i], {
          fontFamily: 'Ascentian',
          fontSize: '32px',
          resolution: 2,
        })
        .setOrigin(0.5)
        .setMask(this._mask)
        .setDepth(DEPTH.MINIGAME);

      this._cells.push(text);
    }
  }

  private _placeRow() {
    this._background = this._scene.add.rectangle(this.x, this.y, this.width, this.height, 0x282828)
      .setStrokeStyle(1, 0x413F3D)
      .setOrigin(0)
      .setDepth(DEPTH.MINIGAME)
      .setInteractive();
    this._mask = this._background.createGeometryMask();
  }

  private _registerEvents() {
    this._background.on('pointerdown', () => {
      this.stopRow();
    });
  }
}